/* eslint-disable no-undef */
import React from 'react';
import './style.sass';

const VirtualSteps = () => (
  <div className="box-shadow">
    <div className="virtual-steps">
      <div className="sidebar">
        <h3 className="sidebar-header">{I18n.t('virtual_office.page.search_steps')}</h3>
        <ul className="numbered-list__orange">
          <li>{I18n.t('virtual_office.page.search_step_1')}</li>
          <li>{I18n.t('virtual_office.page.search_step_2')}</li>
          <li>{I18n.t('virtual_office.page.search_step_3')}</li>
          <li>{I18n.t('virtual_office.page.search_step_4')}</li>
        </ul>
      </div>
    </div>
  </div>
);

export default VirtualSteps;
